module.exports = __webpack_public_path__ + "static/media/video-placeholder.d41fec86.png";